<template>

  <HeaderSection />
  <section id="formulario" class="bg-gray-100 py-12" >
    <Form class="space-y-4 text-gray-700 pb-96">

      <div class="container mx-auto px-4 lg:px-40 max-w-5xl">

        <div class="flex flex-wrap space-y-4 md:space-y-0 mt-6  py-4 border border-gray-500 rounded-md shadow-lg">
          <div class="w-full text-center font-semibold">

            <h1 class="font-bold text-gray-800 mb-0 text-3xl text-center pt-3 font-antonio-bold">
              {{ formData.nombre }} {{ formData.apellido }}
            </h1>
            <h1 class="font-bold text-gray-800 mb-0 text-3xl text-center pt-3 font-antonio-bold">
              {{ formData.mail }} 
            </h1>
            <h1 class="font-bold text-gray-800 mb-0 text-3xl text-center py-14 font-antonio-bold" style="color: #418ea7;">
              Tu correo fue verificado con éxito
            </h1>
          </div>
        </div>

        <div class="flex flex-wrap py-2 mt-3">
          <a href="https://cordobatechweek.com" target="web" class="text-center mt-4 px-4 w-full py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded" :disabled="isSubmitting">
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>IR A LA WEB DEL EVENTO
          </a>
        </div>

      </div>

      <BlockUI :blocked="isSubmitting" fullScreen />

    </Form>
  </section>

</template>

<script lang="ts">
import { useRoute } from 'vue-router'

import { defineComponent } from 'vue';
import { Form } from 'vee-validate';
import Swal from 'sweetalert2'

import BlockUI from 'primevue/blockui';
import HeaderSection from './HeaderSection.vue';

import suiteService, { Acreditado } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';
import { UPDATE } from 'qreventos-suite/constantes';

export default defineComponent({
  components: {
    HeaderSection,
    BlockUI,
    Form
  },
  created () {
    document.title = "Córdoba TechWeek 2026 - Mail";
  },
  data() {
    return {
      isSubmitting: false,
      acreditado: undefined as unknown as Acreditado,
      formData: {
        dni: '',
        nombre: '',
        apellido: '',
        mail: ''
      }
    };
  },
  computed: {
  },
  methods: {
    async verificarMail() {
      this.isSubmitting = true;
			
      try {
        this.acreditado.dato14 = "SI";
        this.acreditado.notificar = false;
        this.acreditado.notificarWhatsApp = false;
        this.acreditado.modificado = UPDATE;
        await suiteService.saveOrUpdate(suiteConfig.evento, this.acreditado);

      } finally {
        this.isSubmitting = false;
      }
    }
  }, 
  async mounted() {
    const route = useRoute();
    const hash = route.params.hash as string;

    this.acreditado = await suiteService.findAcreditadoByHash(suiteConfig.evento, hash);
    if(!this.acreditado) {
      Swal.fire({ title: "Atención!!!", html: "El acreditado no existe.", icon: "error" }).then(() => {
        window.location.href = "https://cordobatechweek.com";
        return;
      });
      return;
    }

    this.verificarMail();
    this.formData.nombre = this.acreditado.nombre;
    this.formData.apellido = this.acreditado.apellido;
    this.formData.mail = this.acreditado.mail;
  }
});
</script>
